<template>
  <div class='coursework-viewer__slide'>
    <div class='coursework-viewer__no-preview'>
      <div class='coursework-viewer__no-preview_icon'>
      <span class='kf-stack kf-stack--circle'>
        <i class='kf kf-circle-outline'></i>
        <i class='kf kf-file-pdf'></i>
      </span>
      </div>
      <div class='coursework-viewer__no-preview_title'>This file can not be previewed</div>
      <div class='coursework-viewer__no-preview_description'>Click on the link below to download the file.</div>
      <div class='coursework-viewer__no-preview_link'>
        <a class='inline-bold-link inline-bold-link--light' target="_blank" v-bind:href="media.download_path">Download</a>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      media: Object
    },
    created() {
      this.$parent.slides.push(this);
    },
    mounted() {
      this.$emit('ready', this.media.id)
    }
  }
</script>